var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7696 2.41078C11.6911 2.33211 11.5979 2.26969 11.4953 2.22711C11.3926 2.18452 11.2826 2.1626 11.1715 2.1626C11.0604 2.1626 10.9504 2.18452 10.8477 2.22711C10.7451 2.26969 10.6519 2.33211 10.5734 2.41078L4.9574 8.02679C4.89475 8.08931 4.84505 8.16357 4.81114 8.24533C4.77722 8.32708 4.75977 8.41472 4.75977 8.50323C4.75977 8.59174 4.77722 8.67938 4.81114 8.76114C4.84505 8.8429 4.89475 8.91716 4.9574 8.97968L10.5734 14.5957C10.9046 14.9268 11.4385 14.9268 11.7696 14.5957C12.1007 14.2645 12.1007 13.7306 11.7696 13.3995L6.87671 8.49985L11.7764 3.60021C12.1007 3.27582 12.1007 2.73517 11.7696 2.41078Z",
    fill: "#1E232C",
    stroke: "#1E232C",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f18695d3e7d99c99568b0942a742df4d.svg";
export { ForwardRef as ReactComponent };